export default "__VITE_ASSET__BVYjCNpm__"